import homeProgress0 from 'url:../../../assets/images/home-progress-0.webp';
import lateralRaiseVideo from 'url:../../../assets/videos/lateral-raise-video.mp4';
import lunges1 from 'url:../../../assets/images/lunges-1.webp';
import lunges2 from 'url:../../../assets/images/lateral-raise-2.webp';

export const lateralRaiseAssets = {
  homeProgress0,
  lateralRaiseVideo,
  lunges1,
  lunges2,
} as const;

export const lateralRaiseAssetList = Object.values(lateralRaiseAssets);
